import {axiosInstance} from "../utils/axios";

export const createTeacherPlayList = (playlistData) => {
    return axiosInstance.post('teachers/play-lists/', playlistData);
}

export const removeTeacherPlayList = (playlistID) => {
    return axiosInstance.delete(`teachers/play-lists/${playlistID}`);
}

export const removeTeacherPlayListInBatch = (playlists) => {
    return axiosInstance.delete(`teachers/play-lists`, {
        data: playlists
    });
}

export const getTeacherPlayList = () => {
    return axiosInstance.get('teachers/play-lists/');
}

export const getRecentPlayList = () => {
    return axiosInstance.get('content/recent-by-teacher');
}

export const getRecentAddedPlayList = async ({queryKey}) => {
    const [_, playlistId] = queryKey;
    return axiosInstance.get(`/teachers/play-lists/${playlistId}`);
}

export const recentAddedPlayList = async (playlistId) => {
    return axiosInstance.get(`/teachers/play-lists/${playlistId}`);
}

export const addPlayListContent = ({playListId, addingPayload}) => {
    return axiosInstance.post(`teachers/play-lists/${playListId}/add-items`, addingPayload);
}

export const removePlaylistContent = ({playlistId, removeContent}) => {
    return axiosInstance.post(`teachers/play-lists/${playlistId}/remove-items`, removeContent);
}

export const searchByTitle = (searchTitle, page = 0, limit = 5) => {
    return axiosInstance.get(`content/search/title?word=${searchTitle}&page=${page}&size=${limit}`);
}
